"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const react_router_dom_1 = require("react-router-dom");
const clsx_1 = __importDefault(require("clsx"));
const WorkItemPillSection_1 = require("@Components/WorkItemPillSection");
const ClickableItemCard_1 = require("@Components/ClickableItemCard");
const CompactWorkItem = (props) => {
    const { work, catalogPath, children, className, handleOnClick } = props;
    return (react_1.default.createElement(ClickableItemCard_1.ClickableItemCard, { className: (0, clsx_1.default)('compact-work-item', className), path: catalogPath, handleOnClick: () => handleOnClick && handleOnClick(work) },
        react_1.default.createElement("div", { className: 'container work-title' },
            catalogPath ? (react_1.default.createElement(react_router_dom_1.Link, { to: catalogPath, className: 'title-link', onClick: (e) => {
                    e.stopPropagation();
                    handleOnClick && handleOnClick(work);
                }, onMouseDown: (e) => {
                    e.stopPropagation();
                } }, work.title)) : (work.title),
            react_1.default.createElement(WorkItemPillSection_1.WorkItemPillSection, { work: work })),
        work.songCode && react_1.default.createElement("div", { className: 'container song-code' }, work.songCode),
        react_1.default.createElement("div", { className: 'container writers' }, work.writers
            .map((writer) => writer && ''.concat(writer.firstName || '', ' ', writer.lastName || '').trim())
            .filter(Boolean)
            .join(', ')),
        children));
};
exports.default = CompactWorkItem;
